import { useSelector } from "react-redux";

import LanguageAwareExternalContent from "~/features/configurator/Linear/components/LanguageAwareExternalContent";
import { type RootState } from "~/app/store";
import { Alert } from "~/common/mui/Alert/Alert";
import { SubstepType } from "~/features/configurator/Linear/dtos";

const DesignationDisclaimer = () => {
  const content = useSelector(selectDisclaimerTextId);

  if (!content) {
    return null;
  }

  return (
    <div className={"mb-60"}>
      <Alert severity={"info"}>
        <LanguageAwareExternalContent content={content} />
      </Alert>
    </div>
  );
};

export default DesignationDisclaimer;

const selectDisclaimerTextId = (state: RootState) => {
  return state.linearConfigurator.substeps[SubstepType.SummaryPage].info;
};
